// File system
let cacheFS: FileSystem

import { DexieFS, MountFS, type FileSystem } from @danielx/lib

export function getCache()
  if (cacheFS) return cacheFS
  fs := new MountFS()
  try
    cacheFS = new DexieFS("composer/cache")
    fs.mount "/cache/", cacheFS
  catch e
    console.warn e

  return cacheFS
